import React, { useState } from "react";
import { Button, Row, Col, Table, Badge, Modal, Spinner } from "react-bootstrap";

import { useGlobalState } from "../../components/globalStateProvider";
import { machineAnalysisStatisticalError } from "../../api/api_definitions";

import ExportComponentComplete from "./DataTableComponents/ExportComponentComplete";


const ButtonStartAnalysisStats = () => {
  const {
    statsBlocks,
    setStatsBlocks,
    dateRangeStats,
    setDateRangeStats,
    alarmCodes,
    setAlarmCodes
  } = useGlobalState();

  const [showResults, setShowResults] = useState(false);
  const [summary, setSummary] = useState([]);
  const [alarmsDF, setAlarmsDF] = useState([])

  const [dataAnalysis, setDataAnalysis] = useState([null, null])

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const disableButton = statsBlocks.some(b => b.snMachine === "") || statsBlocks.length === 0 || alarmCodes.length === 0 || (dateRangeStats[0] === null || dateRangeStats[1] === null);


  const startAnalysisStats = async () => {
    setLoading(true);

    const formatDate = d => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const startDateApi = formatDate(dateRangeStats[0]);
    const endDateApi = formatDate(dateRangeStats[1]);

    const cleanedBlocks = statsBlocks.map(b => ({
      machineFamily: b.machineFamily,
      customerName: b.customerName,
      snMachine: b.snMachine
    }));

    try {
      const dataAPI = await machineAnalysisStatisticalError(
        cleanedBlocks,
        alarmCodes,
        startDateApi,
        endDateApi
      );

      console.log(dataAPI)

      if (!dataAPI) {
        setShowModal(true);
        setLoading(false);
        return;
      }

      /// Estraggo summary dal response
      if (dataAPI.summaryDF) {
        try {
          const parsedSummary = JSON.parse(dataAPI.summaryDF); // <-- PARSING JSON

          console.log(parsedSummary)
          // Convertiamo da oggetti a array di righe
          const summaryArray = Object.keys(parsedSummary.customerName || {}).map(i => ({
            customerName: parsedSummary.customerName[i],
            snMachine: parsedSummary.snMachine[i],
            alarmNo: parsedSummary.alarmNo[i],
            nError: parsedSummary.nError[i],
            RunningTime: parsedSummary.RunningTime[i]
          }));
          setSummary(summaryArray);
        } catch (err) {
          console.error("Errore parsing summary:", err);
          setSummary([]);
        }
      } else {
        setSummary([]);
      }

      setAlarmsDF(dataAPI.alarmsDF)

      setDataAnalysis([startDateApi, endDateApi])

      setShowResults(true);
      setLoading(false);

      // Reset global state
      // setStatsBlocks([
      //   { machineFamily: 0, listCustomerMachines: [], customerName: "", listSNMachines: [], snMachine: "" }
      // ]);
      // setDateRangeStats([null, null]);
      // setAlarmCodes([]);

    } catch (error) {
      console.error(error);
      setShowModal(true);
      setLoading(false);
    }
  };

  return (
    <>
      {/* Error modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Errore</Modal.Title>
        </Modal.Header>
        <Modal.Body>Nessun dato disponibile o errore dalla Lambda.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>

      <Row className="text-center mt-4 mb-4">
        <Col md={{ span: 4, offset: 4 }}>
          <Button size='lg' disabled={disableButton} onClick={startAnalysisStats}>Inizia Analisi</Button>
        </Col>
      </Row>

      {/* LOADING */}
      {loading && (
        <div className="text-center mt-3">
          <p>Caricamento analisi...</p>
          <Spinner animation="border" />
        </div>
      )}

      {/* RESULTS */}
      {!loading && showResults && summary.length > 0 && (
        <>
          <Row className="mt-5">
            <Col>
              <h3>Riepilogo Analisi</h3>
              <h6>Periodo considerato: {dataAnalysis[0]} - {dataAnalysis[1]}</h6>
              <Table striped bordered hover responsive>
                {/* ... qui va la tua tabella ... */}
              </Table>

              {/* Pulsante Export */}
              <ExportComponentComplete summary={summary} alarmsDF={alarmsDF} dateRange={dataAnalysis} />
            </Col>
          </Row>

          <Row className="mt-5 mb-5">
            <Col>
              <h3>Riepilogo Analisi</h3>
              <h6>Periodo considerato: {dataAnalysis[0]} - {dataAnalysis[1]}</h6>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Cliente</th>
                    <th>SN Machine</th>
                    <th>Errore</th>
                    <th>Numero Occorrenze</th>
                    <th>Running Time (h)</th>
                  </tr>
                </thead>
                <tbody>
                  {summary.map((row, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{row.customerName}</td>
                      <td>{row.snMachine}</td>
                      <td>
                        <Badge bg="danger">{row.alarmNo}</Badge>
                      </td>
                      <td>{row.nError}</td>
                      <td>
                        <Badge bg="success">{row.RunningTime.toFixed(2)}</Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ButtonStartAnalysisStats;
